import { api } from "../api";

/** A Direct Data chega a levar ~17s; o backend desiste em 35s, entao 45s garante que o front sempre receba resposta. */
const DIRECTD_TIMEOUT_MS = 45000;

/**
 * findDriverDirectdByCpf - Function that looks up the driver's CNH on Direct Data (cached for 30 days on the backend)
 * /drivers/directd/{cpf}
 * method GET
 * @async-function
 */
const findDriverDirectdByCpf = async (token: string, cpf: string) => {
    const response = await api.get(
        `/drivers/directd/${encodeURIComponent(cpf)}`, {
            timeout: DIRECTD_TIMEOUT_MS,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default findDriverDirectdByCpf;
